const downloadSection = document.querySelector('.downloads_section')
if (downloadSection) {
  const downloadWrappers = downloadSection.querySelectorAll('.download-main-wrapper')
  if (downloadWrappers) {
    Array.prototype.forEach.call(downloadWrappers, (dlWrap) => {
      const dlDropdown = dlWrap.querySelector('select')
      const dlButton = dlWrap.querySelector('.download-button')
      dlDropdown.addEventListener('change', () => {
        dlButton.setAttribute('href', dlDropdown.value)
      })
    })
  }
}